import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelText as _vModelText, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-wrap default-modal"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "modal-backdrop fade show" }, null, -1)
const _hoisted_3 = {
  class: "modal fade show d-block",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_4 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-header" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Chat Channel", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "mb-3" }, "Please select preferred Chat Channel:", -1)
const _hoisted_12 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "new"
}, "New", -1)
const _hoisted_14 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "existing"
}, "Use Existing Channel", -1)
const _hoisted_16 = {
  key: 0,
  class: "form-group bg-light p-2"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { for: "user.id" }, "Select Channel", -1)
const _hoisted_18 = {
  disabled: "",
  value: ""
}
const _hoisted_19 = {
  key: 1,
  class: "form-group bg-light p-2"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { for: "channelName" }, "Channel Name", -1)
const _hoisted_21 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.showPhaseChannel)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hidePhaseChannel && _ctx.hidePhaseChannel(...args)))
                  }, [
                    _hoisted_8
                  ])
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_ErrorList, {
                    errors: _ctx.state.ui.error.errorList.phaseChatChannel,
                    hasError: _ctx.state.ui.error.hasError
                  }, null, 8, ["errors", "hasError"]),
                  _createVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode("div", _hoisted_12, [
                      _withDirectives(_createVNode("input", {
                        class: "custom-control-input",
                        type: "radio",
                        id: "new",
                        name: "fav_language",
                        value: "NEW",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.channelType.type = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.state.data.channelType.type]
                      ]),
                      _hoisted_13
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _withDirectives(_createVNode("input", {
                        class: "custom-control-input",
                        type: "radio",
                        id: "existing",
                        name: "fav_language",
                        value: "EXISTING",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.channelType.type = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.state.data.channelType.type]
                      ]),
                      _hoisted_15
                    ])
                  ]),
                  (_ctx.state.data.channelType.type === 'EXISTING')
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _withDirectives(_createVNode("select", {
                          disabled: !_ctx.state.data.phaseChannelList.length,
                          class: "form-control mb-2",
                          id: "user.id",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.channelType.channelSelected = $event))
                        }, [
                          _createVNode("option", _hoisted_18, _toDisplayString(_ctx.state.data.phaseChannelList.length === 0 ? 'No existing channel' : 'Select the channel'), 1),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.phaseChannelList, (item, itemIndex) => {
                            return (_openBlock(), _createBlock("option", {
                              key: itemIndex,
                              value: item.id,
                              title: _ctx.getMemberNames(item.activeMember)
                            }, _toDisplayString(item.name), 9, ["value", "title"]))
                          }), 128))
                        ], 8, ["disabled"]), [
                          [_vModelSelect, _ctx.state.data.channelType.channelSelected]
                        ])
                      ]))
                    : (_ctx.state.data.channelType.type === 'NEW')
                      ? (_openBlock(), _createBlock("div", _hoisted_19, [
                          _hoisted_20,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "channelName",
                            placeholder: "Provide the channel name",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.channelType.channelName = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.channelType.channelName]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.proceedForChatChannel && _ctx.proceedForChatChannel(...args)))
                  }, "Proceed"),
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hidePhaseChannel && _ctx.hidePhaseChannel(...args)))
                  }, "Cancel")
                ])
              ])
            ])
          ]),
          (_ctx.state.data.showSuccesCustomModal)
            ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
                key: 0,
                onClose: _ctx.closeSuccessCustomModal,
                showModal: _ctx.state.data.showSuccesCustomModal,
                titleMessage: _ctx.state.data.successFulMessage
              }, null, 8, ["onClose", "showModal", "titleMessage"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}